import sectionBlockMeta from './block.json';
import sectionIcon from './icon';
import attributeVisibility from '@components/visibility/attributes.json';
import { attributeBackgroundTypes } from '@components/background-types/attributes';
import attributeClassDropDown from '@components/class-dropdown/attributes.json';
import attributeBlockSpacing from '@components/spacing-selector/attributes';
import { getBlockLabelByName } from '@helpers/utils';
import edit from './edit';
import save from './save';
import './style.scss';

const { registerBlockType } = wp.blocks;
const { name, ...settings } = sectionBlockMeta;

const attributes = {
  ...settings.attributes,
  ...attributeVisibility,
  ...attributeBackgroundTypes,
  ...attributeClassDropDown,
  ...attributeBlockSpacing,
};

registerBlockType(name, {
  ...settings,
  icon: sectionIcon,
  attributes,
  edit,
  save,
  __experimentalLabel: (attributes) =>
    getBlockLabelByName(attributes, settings.title),
});
